import { FC } from "react"

// components
import { FooterBase, FooterNavCopy } from "./FooterBase"

// utils
import { events } from "../../utils/heap/tracking_events"

// styles
// @ts-ignore
import { edsLMarTop4 } from "../../theme/global.module.scss"
import {
  globalFooter,
  footerHeading,
  footerInnerContainer,
  footerLi,
  footerColumnSection,
  footerLinks
} from "./Footer.module.scss"
import { Typography } from "@eventbrite/marmalade"

export type FooterCopy =
  Queries.HomepageDataQuery["contentfulFooter"]["footerReference"]

type Props = {
  footerCopy: FooterCopy
  footerNavCopy: FooterNavCopy
}

export const Footer: FC<Props> = ({ footerCopy, footerNavCopy }) => {
  return (
    <footer className={globalFooter}>
      <div>
        <div className={footerInnerContainer}>
          <div className={footerColumnSection}>
            {footerCopy?.map((footerLink, i) => (
              <ul key={`${footerLink}__${i}`}>
                <li>
                  <h3 className={footerHeading}>{footerLink.displayText}</h3>
                </li>
                <li>
                  <div className={edsLMarTop4} />
                </li>
                <li className={footerLi}>
                  <ul>
                    {footerLink.FooterNavigationChildItems.map(
                      ({ displayText, footerNavigationUrl }, i) => {
                        return (
                          <li
                            key={`${displayText}__${i}`}
                            className={footerLinks}
                          >
                            <a
                              href={footerNavigationUrl}
                              target="_blank"
                              onClick={(e) => {
                                e.preventDefault()

                                events?.footerLinkClick(
                                  `${displayText} - ${encodeURI(
                                    footerNavigationUrl
                                  )}`,
                                  Footer?.name
                                )

                                if (typeof window !== "undefined") {
                                  window.open(footerNavigationUrl, "_newtab")
                                }
                              }}
                            >
                              <Typography variant="body-sm">
                                {displayText}
                              </Typography>
                            </a>
                          </li>
                        )
                      }
                    )}
                  </ul>
                </li>
              </ul>
            ))}
          </div>
          <FooterBase footerNavCopy={footerNavCopy} />
        </div>
      </div>
    </footer>
  )
}
